/**
 * Shared visual language for AI Ops surface (Phase 3.C + Module G).
 *
 * Gradient palette mirrors the per-card themes used in the owner app
 * (sut_driver `ai_insights.screen.dart`) so the admin view feels like
 * an extension of the same product, not a different app. Indigo/violet
 * = primary AI / Insights; emerald = success / healthy; amber = warning
 * / low-confidence; rose = error / abandoned; slate = neutral.
 */

export const AI_OPS_GRADIENTS = {
  indigo:  ["#6366F1", "#4F46E5"],   // primary — Insights / AI brand
  violet:  ["#A78BFA", "#7C3AED"],   // routes, conversational
  emerald: ["#34D399", "#059669"],   // revenue, success
  amber:   ["#FBBF24", "#EA580C"],   // warning, drivers
  rose:    ["#FB7185", "#E11D48"],   // error, alerts
  slate:   ["#CBD5E1", "#94A3B8"],   // muted / no-data
  cyan:    ["#22D3EE", "#0891B2"],   // booking
  pink:    ["#F472B6", "#DB2777"],   // mic / audio
};

/** Shadow color companion for each gradient (the 2nd stop). */
export const AI_OPS_SHADOWS = {
  indigo:  "#4F46E5",
  violet:  "#7C3AED",
  emerald: "#059669",
  amber:   "#EA580C",
  rose:    "#E11D48",
  slate:   "#94A3B8",
  cyan:    "#0891B2",
  pink:    "#DB2777",
};

/** Status → chip color mapping (MUI palette names). Used by `_StatusChip`. */
export const STATUS_COLORS = {
  // Insights /ask statuses
  answered:        "success",
  unknown_intent:  "warning",
  handler_error:   "error",
  narrator_error:  "error",
  error:           "error",

  // Booking statuses
  extracted:  "success",
  clarified:  "info",
  confirmed:  "success",
  abandoned:  "warning",
};

/** Section background tints — used as page bg / card bg accents. */
export const AI_OPS_BG = {
  page:        "#F6F7FB",
  cardBorder:  "#E5E7EB",
  cardBorderActive: "#CBD5E1",
  rowHover:    "#F8FAFC",
  zebra:       "#FAFAFC",
};
